import { Icon } from '@iconify/react';
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import bugFilled from '@iconify/icons-ant-design/bug-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import CountUp from 'react-countup';
import TokenDecoder from '../../../helpers/TokenDecoder';
// import PaidIcon from '@mui/icons-material/Paid';
import LocalMallIcon from '@material-ui/icons/LocalMall';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import VPUDashboardService from './VPUDashboardService'


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: theme.palette.error.darker,
    backgroundColor: theme.palette.error.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.error.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
        theme.palette.error.dark,
        0.24
    )} 100%)`
}));

// ----------------------------------------------------------------------

export default function TodayOrderCountVPU() {

    //const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

    const [todayOrder, setTodayOrder] = useState(0);

    async function GetTodayOrderCount() {
        const response = await VPUDashboardService.GetTodayOrderCount();
        if (response.length > 0) {
            setTodayOrder(response[0].orderCount);
        }
    }
    useEffect(() => {
        GetTodayOrderCount();
    }, [])

    return (
        <RootStyle>
            <IconWrapperStyle>
                <LocalMallIcon fontSize='large' width={24} height={24} />
            </IconWrapperStyle>
            <Typography variant="h3"><CountUp end={todayOrder} /></Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                Today Orders
            </Typography>
        </RootStyle>
    );
}
